import { ArrowUpIcon } from '../ui/Icon/Icon'
import { useScrollPosition } from '../../hooks/useScrollPosition'
import styles from './ScrollToTop.module.css'

const ScrollToTop = () => {
  const isVisible = useScrollPosition(600)

  return (
    <a
      href="#top"
      className={`${styles.button} ${isVisible ? styles.visible : ''}`.trim()}
      aria-label="Back to top"
      title="Back to top"
      tabIndex={isVisible ? undefined : -1}
      aria-hidden={!isVisible}
    >
      <ArrowUpIcon size={18} />
    </a>
  )
}

export default ScrollToTop
